module.exports = __webpack_public_path__ + "img/kit.fd908d45.jpg";